export default "__VITE_ASSET__ChVig3CX__"